import { Component, OnInit } from '@angular/core';
import { GlobalserviceService } from '../globalservice.service';
import { NgForm } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';

@Component({
  selector: 'app-admin-user',
  templateUrl: './admin-user.component.html',
  styleUrls: ['./admin-user.component.css']
})
export class AdminUserComponent implements OnInit {
  allData = []; datanull = false;
  details = [];
  Create: any;
  currentpage: number;
  totalItems: number;
  p: number = 1;
  newPost: { title: any; body: any; };
  title: any;
  body: any;op2;op1;

  constructor(public globalservice: GlobalserviceService, private router: Router, public snackBar: MatSnackBar ) { }

  ngOnInit() {
    this.all_LocationFn();
    this.User_details();
    // this.op2=false;
    // this.op1=true;
  }
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    });
  }
  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/ ;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  keyPresss(event: any) {
    const pattern = /^[a-zA-Z]*$/ ;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  all_LocationFn() {
   this.globalservice.enableloader();
    this.globalservice.location().subscribe(responsedata => {
     this.globalservice.disableloader();
      if (responsedata.Success) {
        this.allData = responsedata['Data'];
      }
       this.op2=false;
       this.op1=true;
    },
      err => {
        this.globalservice.disableloader();
        alert("Network Error");
      });
  }
 

  passFn(data,method) {
    if(method){
    var registeruser =
    {
      "ADMIN_EMP_ID": data.EmployedID,
      "PASSWORD": data.Password,
      "NAME": data.Name,
      "LOCATION": data.Location.location,
      "MOBILE_NO": data.MobileNo,
      "EMAIL_ID": data.email,
    }
    this.globalservice.enableloader();
    this.globalservice.createUser(registeruser).subscribe(responsedata => {
     this.globalservice.disableloader();
      if (responsedata.Success) {
        this.Create = responsedata['Data'];
       this.snackBar.open('User created Successfully', '', { duration: 3000 });
        data.resetForm();
        this.User_details();
        this.op2=true;
        this.op1=false;
      } 
        else{
          this.Create= responsedata['Message']
           this.snackBar.open(this.Create ,'', { duration: 3000 });
         }
    },
      err => {
        this.globalservice.disableloader();
        alert("Network Error");
      });
    }
  }

  User_details() {
    this.globalservice.enableloader();
    this.globalservice.Userall().subscribe(responsedata => {
    this.globalservice.disableloader();
      if (responsedata.Success) {
        this.details = responsedata['Data'];
        this.datanull = responsedata["Data1"];
        this.datanull = true;

      }
    },
      err => {
        this.globalservice.disableloader();
        alert("Network Error");
      });
  }
  
  pagechange(event) {
    this.currentpage = event;
  }


 valuemeth(data){
  var level = {
    "Name":data
 }
 this.globalservice.admin_search(level).subscribe(responsedata => {
 if (responsedata.Success) {
   this.details = responsedata['Data'];
    }
    else{
       this.User_details();  
      }
  },
   err => {
     this.globalservice.disableloader();
     alert("Network Error");
   });
}
}
